<template>
  <!-- <TopNav class="hidden"/>-->

  <div class="relative h-screen grid bg-gray-50 sm:ml-12"
    :class="{'grid grid-cols-12   ' : (chatOpened && isChatVisible), 'w-full':(!chatOpened&&isChatVisible)}">

    <SideNav />


    <div class="h-screen flex flex-col  bg-gray-50 "
      :class="{'  col-span-9' : (chatOpened &&isChatVisible), 'col-span-12': (!chatOpened && isChatVisible)}">

      <div class="flex-none  ">

        <div class=" w-full  bg-gray-800 flex-none h-9" v-if="isMultiSite">
          <div class="relative inline-flex rounded-md shadow-sm" role="group">
            <button type="button" class="px-4 pb-1 pt-2 text-xs font-medium     cursor-pointer  text-white border-b-4 w-48"
              :class="{'   font-bold  border-green-300': (selected==0), 'border-gray-800    hover:border-orange-500 ' : (selected!=0)}"
              @click="selectSite(0,'all')">
              Tous les sites
            </button>
            <button v-for="(entity, index) in user?.tenant?.entities" :key="entity.id" type="button"
              class="px-0 pb-1 pt-2  text-xs font-medium  text-white  border-b-4 cursor-pointer px-2 w-48"
              :class="{'   font-bold  border-green-300': (selected== (index+1)), ' border-gray-800  hover:border-orange-500 ' : (selected!= (index+1))}"
              @click="selectSite(index + 1, entity._id)">
              {{ entity.name }}
            </button>
          </div>
          <div class="absolute top-0  right-9 justify-center w-16 h-9 flex items-center text-white cursor-pointer w-48" @click="openWindow">
            <i class="fa-regular fa-arrow-up-right-from-square mb-1"></i>
                     </div>
        </div>

      </div>
      <div class="flex-1 overflow-auto  bg-gray-50">
        <router-view class="w-full" :refresh="timestamp" @openMenu="openMenu" />
      </div>


    </div>

 

    <div class="absolute top-10 right-12" :class="{'hidden': (chatOpened  )}" @click="onOpenChat">
      <button type="button"
        class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-full text-sm p-2.5 text-center inline-flex items-center me-2   ">
        <span class="li8jS" data-animate="false">
          <svg width="14" height="15" viewBox="0 0 14 15" fill="currentColor" xmlns="http://www.w3.org/2000/svg"
            class="_1gQDs _3FkP7">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M7 0.714966C6.57172 0.714966 6.19841 1.00644 6.09453 1.42193C5.64458 3.22175 5.11525 4.31311 4.3567 5.07167C3.59815 5.83022 2.50678 6.35955 0.706966 6.8095C0.291477 6.91337 -3.32794e-07 7.28669 -3.32794e-07 7.71497C-3.32794e-07 8.14324 0.291477 8.51656 0.706966 8.62043C2.50678 9.07039 3.59815 9.59971 4.3567 10.3583C5.11525 11.1168 5.64458 12.2082 6.09453 14.008C6.19841 14.4235 6.57172 14.715 7 14.715C7.42828 14.715 7.80159 14.4235 7.90547 14.008C8.35542 12.2082 8.88475 11.1168 9.6433 10.3583C10.4019 9.59971 11.4932 9.07039 13.293 8.62043C13.7085 8.51656 14 8.14324 14 7.71497C14 7.28669 13.7085 6.91337 13.293 6.8095C11.4932 6.35955 10.4019 5.83022 9.6433 5.07167C8.88475 4.31311 8.35542 3.22175 7.90547 1.42193C7.80159 1.00644 7.42828 0.714966 7 0.714966Z">
            </path>
          </svg>
          <svg width="14" height="15" viewBox="0 0 14 15" fill="currentColor" xmlns="http://www.w3.org/2000/svg"
            class="_1gQDs _1hXL0">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M7 0.714966C6.57172 0.714966 6.19841 1.00644 6.09453 1.42193C5.64458 3.22175 5.11525 4.31311 4.3567 5.07167C3.59815 5.83022 2.50678 6.35955 0.706966 6.8095C0.291477 6.91337 -3.32794e-07 7.28669 -3.32794e-07 7.71497C-3.32794e-07 8.14324 0.291477 8.51656 0.706966 8.62043C2.50678 9.07039 3.59815 9.59971 4.3567 10.3583C5.11525 11.1168 5.64458 12.2082 6.09453 14.008C6.19841 14.4235 6.57172 14.715 7 14.715C7.42828 14.715 7.80159 14.4235 7.90547 14.008C8.35542 12.2082 8.88475 11.1168 9.6433 10.3583C10.4019 9.59971 11.4932 9.07039 13.293 8.62043C13.7085 8.51656 14 8.14324 14 7.71497C14 7.28669 13.7085 6.91337 13.293 6.8095C11.4932 6.35955 10.4019 5.83022 9.6433 5.07167C8.88475 4.31311 8.35542 3.22175 7.90547 1.42193C7.80159 1.00644 7.42828 0.714966 7 0.714966Z">
            </path>
          </svg>
          <span class="_4pE1e"></span>
        </span> <span class="sr-only">Icon description</span>
      </button>





    </div>
  </div>
  <div id="drawer-main-menu"
    class="fixed top-0 left-0 z-40 w-72 h-screen p-4 overflow-y-auto transition-transform -translate-x-full bg-white "
    tabindex="-1" aria-labelledby="drawer-navigation-label">
    <h5 id="drawer-main-label" class="text-base font-semibold text-gray-500 uppercase ">Menu</h5>
    <button type="button" @click="closeMenu"
      class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 absolute top-2.5 end-2.5 inline-flex items-center ">
      <svg aria-hidden="true" class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd"
          d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
          clip-rule="evenodd"></path>
      </svg>
      <span class="sr-only">Close menu</span>
    </button>
    <div class="py-4 overflow-y-auto">
      <ul class="space-y-2 font-medium w-full flex justify-start flex-col">
        <li v-for="item in config?.items" :key="item.id"
          class="hidden flex flex-row items-center justify-start bg-blue-200">
          <i class=" flex justify-center items-center  w-6 h-6  lg:w-8 lg:h-8 xl:w-12 xl:h-12  transition duration-75 group-hover:text-white  "
            :class="item.icon" />
          <div class="ml-3 text-left truncate bg-orange-200">{{item.name[lg]}}</div>

        </li>


        <li v-for="item in config?.items" :key="item.id" class2="flex flex-row items-center justify-start bg-blue-200">

          <button type="button"
            class="flex items-center w-full p-2 text-base text-gray-900 transition duration-75 rounded-lg group hover:bg-gray-100  "
            :aria-controls="`dropdown-example-${item.id}`" :data-collapse-toggle="`dropdown-example-${item.id}`">
            <i class=" flex flex-shrink-0 justify-center items-center  w-6 h-6  lg:w-8 lg:h-8 xl:w-12 xl:h-12  transition duration-75 group-hover:text-white  "
              :class="item.icon" />
            <div class="flex-1 ms-3 text-left rtl:text-right whitespace-nowrap truncate bg-orange-200">{{item.name[lg]}}</div>
            <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="m1 1 4 4 4-4" />
            </svg>
          </button>
          <ul :id="`dropdown-example-${item.id}`" class="hidden py-2 space-y-2">
            <li>
              <a href="#"
                class="flex items-center w-full p-2 text-gray-900 transition duration-75 rounded-lg pl-11 group hover:bg-gray-100  ">Products</a>
            </li>
            <li>
              <a href="#"
                class="flex items-center w-full p-2 text-gray-900 transition duration-75 rounded-lg pl-11 group hover:bg-gray-100  ">Billing</a>
            </li>
            <li>
              <a href="#"
                class="flex items-center w-full p-2 text-gray-900 transition duration-75 rounded-lg pl-11 group hover:bg-gray-100  ">Invoice</a>
            </li>
          </ul>

        </li>

      </ul>
    </div>
  </div>
  <!-- drawer init and toggle -->
</template>
<style>
  ._1gQDs {
    display: block;
    will-change: transform;
  }

  .Wmjjd svg {
    display: block;
    width: 18px;
    height: 18px;
    position: relative;
    top: 1px;
  }

  span.li8jS ._3FkP7 {
    position: absolute;
    top: 2px;
    left: 3px;
    width: 14px;
    height: 15px;
    transform-style: preserve-3d;
    backface-visibility: visible;
    transform: rotateY(0);
  }

  .li8jS {
    position: relative;
    display: block;
    width: 18px;
    height: 18px;
    perspective: 1000px;
    transition: transform .3s var(--cubic-move);
  }

  [data-icon-only=false] .hfCtL {
    opacity: 1;
    width: var(--text-width);
    transition: width .35s var(--cubic-move), opacity .4s ease .25s;
  }

  ._1gQDs {
    display: block;
    will-change: transform;
  }

  .Wmjjd svg {
    display: block;
    width: 18px;
    height: 18px;
    position: relative;
    top: 1px;
  }

  span.li8jS ._1hXL0 {
    position: absolute;
    top: 1px;
    left: 0;
    width: 6px;
    height: 6px;
    transition: opacity .25s ease;
  }

  .hfCtL {
    --text-width: 64px;
    display: inline-block;
    position: relative;
    left: 4px;
    width: 0;
    opacity: 0;
    overflow: hidden;
    text-align: left;
    transition: width .35s var(--cubic-move), opacity .15s ease;
  }

  ._6jr41 {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 4px;
    width: 100%;
    height: 100%;
    padding-bottom: 1.5px;
    transition: opacity .15s ease .1s;
  }


  span.li8jS {
    --particle-opacity: .7;
  }

  * {
    scrollbar-width: thin;
  }
</style>

<script>
  // import TopNav from '@/components/TopNav.vue'
  import SideNav from '@/components/SideNav.vue'
   
  import { mapActions, mapGetters } from "vuex";
  import { Drawer } from 'flowbite';
  import service from "@/services/FullService.vue"

  export default {
    name: 'AdminLayout',
     emits: ["openMenu"],  
    data() {
      return {
        selected: 0,
        timestamp: null,
        chatOpened: false,
        drawerMenu: null,
        lg: "FR",
        config: {}
      }
    },
    computed: {
      isMultiSite: function () {
        //return (this.user?.tenant?.entities?.length > 0)
        return (this.user?.isMultiEntities == true) 
      },
      ...mapGetters({ user: "StateUser" }),
      isLoggedIn: function () {
        return this.$store.getters.isAuthenticated;
      },
      'isChatVisible': function () {
        if (this.user?.isChatActivated == true) return true;
        return false
      },
    },
    watch: {
      'user.entity_id': function () {
        this.timestamp = (new Date()).toISOString()
      },
      'user.tenant_id': function () {
        this.timestamp = (new Date()).toISOString()
        this.loadMenu()
      }
    },
    mounted() {
      if (this.user?.entity_id == "66a4a19c8d43c894c147758a") this.selected = 1;
      if (this.user?.entity_id == "66a4a1cb8d43c894c147758b") this.selected = 2;

      this.timestamp = (new Date()).toISOString()
      this.loadMenu()
    },
    methods: {
      openWindow()
      {
        window.open(this.$route.path, '_blank');

      },
      closeMenu() {
        console.log("close menu")
        this.drawerMenu.hide()
      },
      openMenu() {

        if (this.drawerMenu == undefined) {
          const $targetEl = document.getElementById('drawer-main-menu');
          // options with default values
          const options = {
            placement: 'left',
            backdrop: true,
            bodyScrolling: false,
            edge: false,
            edgeOffset: '',
            backdropClasses:
              'bg-gray-900/50 /80 fixed inset-0 z-30',
            //onHide: () => {
            //  console.log('drawer is hidden');
            //},
            //onShow: () => {
            //  console.log('drawer is shown');
            //},
            //onToggle: () => {
            //  console.log('drawer has been toggled');
            //},
          };

          // instance options object
          const instanceOptions = {
            id: 'drawer-main-menu',
            override: true
          };

          this.drawerMenu = new Drawer($targetEl, options, instanceOptions);
        }
        this.resetSelectedIndicators = (new Date()).getTime()
        this.drawerMenu.show()
      },
      loadMenu: async function () {
        if (this.user == undefined) return;

        //  let config = await service.getData("sidemenus", this.user?.token, Object.assign({}, { limit: 1, offset: 0 }, {}))

        //  console.log("SIDEMENU ------------------------------------------------------------")
        //  console.log(JSON.stringify(config))



        let config2 = await service.getSideMenus(this.user?.token)

        //console.log("SIDEMENU 2------------------------------------------------------------")
        //console.log(JSON.stringify(config2))
        if ((config2 != undefined)) {

          this.config = config2
          return;
        }

        this.config = { items: [] }

      },
      ...mapActions(["ChangeEntity"]),

      onOpenChat() {
        if (this.user?.isChatActivated != true) return;
        this.chatOpened = true
      },
      closeChat() {

        this.chatOpened = false
      }, openChat() {

        this.chatOpened = true
      },
      selectSite(n, id) {
        this.selected = n
        this.ChangeEntity(id)
      }
    },
    components: {
      SideNav 
    }
  }
</script>